import React from 'react'

import './Version.css'

const Version = () => (
    <div className="version-wrapper">
        { process.env.REACT_APP_VERSION && (
            <div className="version">
                v
                { process.env.REACT_APP_VERSION }
            </div>
        ) }
    </div>
)

export default Version
